import { authGet } from './authMiddleware';

export const getMinePersonnelAutocomplete = async (query) => {
    return authGet(`api/Personnel/AutoComplete?keywords=${query}`);
}